import React from 'react';
import type { InputNode } from '../types';

// 与 V1 htmlGenerator.ts:42-46 同款标点集合 / 判定：trim 后是「单个标点」即视为行内标点。
const PUNCT_RE = /[;；，,。.!！?？：:、]/;
const isOnlyPunct = (text?: string) => {
  const t = (text ?? '').trim();
  return t.length === 1 && PUNCT_RE.test(t);
};

export const TextNode: React.FC<{ node: InputNode }> = React.memo(({ node }) => {
  // V1 parity（htmlGenerator.ts:183-190）：纯标点 text 节点（如 ";\n"）丢掉换行、
  // 只渲染标点本身并标 rte-inline-punct（display:inline）。否则 v2 naïve 的 \n→<br/>
  // 会让 ";\n" 多吐一个 <br/>，与后续 " \n请为我分析" 的 <br/> 叠成一条空行（中间大间隔）。
  // 注：V1 还会把标点黏进前一个 chip（rte-inline-group）防孤儿换行；v2 此处仅去换行即可
  //     消除空行，标点紧跟前一节点同行渲染，视觉与 V1 一致。
  if (isOnlyPunct(node.text) && !node.className && !node.exclusionGroup) {
    return (
      <span data-type="text" className="rte-inline-punct" contentEditable={false}>
        {(node.text ?? '').trim()}
      </span>
    );
  }

  const html = (node.text ?? '').replace(/\n/g, '<br/>');

  const textEl = (
    <span
      data-type="text"
      className={node.className}
      contentEditable={false}
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );

  // V1 parity (htmlGenerator.ts:122-124): 任何含 exclusionGroup 的节点都包一层
  // <span class="exclusion-wrapper" data-group="${exclusionGroup}">。这条 wrapper
  // 让 CSS 的 .exclusion-wrapper[data-group="separator"] 能命中（30px 居中对齐 "或"
  // 等分隔文本，与同行的 chip token 视觉齐高）。
  if (node.exclusionGroup) {
    return (
      <span className="exclusion-wrapper" data-group={node.exclusionGroup}>
        {textEl}
      </span>
    );
  }
  return textEl;
});
TextNode.displayName = 'TextNode';
